<template>
  <transition name="terms-modal-fade">
    <div v-if="modelValue" class="terms-modal" @click="closeModal">
      <div ref="dialog" class="terms-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="terms-modal-title" tabindex="-1" @click.stop>
        <div class="terms-modal__header">
          <div>
            <small class="terms-modal__eyebrow">{{ activeContent.eyebrow }}</small>
            <h3 id="terms-modal-title">{{ activeContent.title }}</h3>
          </div>
          <button type="button" class="terms-modal__close" aria-label="Cerrar" @click="closeModal">
            <span aria-hidden="true">x</span>
          </button>
        </div>

        <div class="terms-modal__tabs" role="tablist" aria-label="Secciones legales">
          <button
            v-for="section in sectionOrder"
            :key="section.key"
            type="button"
            :class="['terms-modal__tab', { 'is-active': section.key === activeView }]"
            @click="setView(section.key)"
          >
            {{ section.label }}
          </button>
        </div>

        <div ref="body" class="terms-modal__body">
          <p class="terms-modal__lead">{{ activeContent.lead }}</p>

          <div class="terms-modal__prose">
            <p v-for="paragraph in activeContent.paragraphs" :key="paragraph">
              {{ paragraph }}
            </p>
          </div>

          <ul v-if="activeContent.highlights && activeContent.highlights.length" class="terms-modal__list">
            <li v-for="item in activeContent.highlights" :key="item">{{ item }}</li>
          </ul>
        </div>

        <div class="terms-modal__footer">
          <span class="terms-modal__footer-copy">Consulta legal sin salir del checkout.</span>
          <button type="button" class="terms-modal__action" @click="closeModal">Entendido</button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
const LEGAL_SECTIONS = {
  terms: {
    label: 'Terminos',
    eyebrow: 'Legal',
    title: 'Terminos y condiciones',
    lead: 'Condiciones aplicables al uso de FOMOPLANES y a cada compra realizada en la plataforma.',
    paragraphs: [
      'Estos terminos aplican a todas las versiones del sitio y aplicaciones de FOMOPLANES operadas por GINGO ENTERPRISES LLC. Al visitar el sitio, registrarte o comprar entradas, aceptas estas condiciones y sus futuras actualizaciones.',
      'FOMOPLANES es operado por GINGO ENTERPRISES LLC, empresa registrada en Estados Unidos, con direccion comercial en 1209 MOUNTAIN ROAD PL NE STE R, ALBUQUERQUE, NM 87110, Estados Unidos. El correo oficial de soporte publicado para la plataforma es fomoplanes@sudenec.com.',
      'GINGO ENTERPRISES LLC opera FOMOPLANES unicamente como plataforma de intermediacion para la comercializacion, promocion y gestion digital de accesos. Los eventos publicados son responsabilidad de sus organizadores, salvo que un evento sea identificado expresamente como propio o coorganizado por FOMOPLANES.',
      'La informacion personal entregada para registro, validacion y compra se usa solo para fines del servicio. GINGO ENTERPRISES LLC no almacena datos completos de tarjetas en la plataforma y los pagos pueden procesarse mediante Stripe u otros procesadores autorizados.',
      'El usuario es responsable de revisar fecha, funcion, localidad y cantidad antes de pagar. No hay cambios, devoluciones ni reembolsos por errores del comprador ni por fees ya aceptados.',
      'En caso de cancelacion, reprogramacion o devoluciones, la responsabilidad principal recae en el organizador. GINGO ENTERPRISES LLC no es responsable por esas decisiones ni por su ejecucion final, aunque puede colaborar con la gestion cuando exista autorizacion previa o acuerdo formal.',
      'Si agregas Fomo Safe durante el checkout, ese valor se cobra como addon independiente y su cobertura queda sujeta a elegibilidad, revision documental y validacion interna de GINGO ENTERPRISES LLC.',
      'Estas condiciones se interpretan conforme a la legislacion aplicable de Estados Unidos y, cuando corresponda, del Estado de Nuevo Mexico.',
    ],
  },
  privacy: {
    label: 'Privacidad',
    eyebrow: 'Datos y privacidad',
    title: 'Politica de privacidad',
    lead: 'Asi tratamos la informacion necesaria para registro, pagos, tickets, soporte y prevencion de fraude.',
    paragraphs: [
      'GINGO ENTERPRISES LLC, operador de FOMOPLANES y empresa registrada en Estados Unidos, puede recopilar nombre, apellido, correo electronico, telefono, direccion de facturacion, datos del pedido, datos de asistentes e informacion adicional requerida por cada evento para emitir o validar accesos.',
      'Tambien podemos recopilar datos tecnicos razonables de navegacion, dispositivo, geolocalizacion aproximada, cookies, identificadores de sesion y registros de actividad para seguridad, analitica y funcionamiento del sitio.',
      'GINGO ENTERPRISES LLC utiliza esa informacion para crear cuentas, confirmar pagos, emitir tickets, atender soporte, notificar cambios de eventos, prevenir fraude, cumplir obligaciones legales y mejorar la experiencia de compra.',
      'Los pagos pueden procesarse mediante Stripe y otros procesadores autorizados. GINGO ENTERPRISES LLC no almacena datos completos de tarjetas de credito o debito en sus propios sistemas para FOMOPLANES.',
      'GINGO ENTERPRISES LLC puede compartir informacion con organizadores del evento, procesadores de pago, proveedores de tecnologia, servicios de correo, herramientas de analitica, servicios antifraude y autoridades competentes cuando exista base legal o necesidad operativa legitima.',
    ],
  },
  refunds: {
    label: 'Reembolsos',
    eyebrow: 'Compras y soporte',
    title: 'Reembolsos y cancelaciones',
    lead: 'Politica publica aplicable a cancelaciones, reprogramaciones, errores de compra y revisiones relacionadas con Fomo Safe.',
    paragraphs: [
      'GINGO ENTERPRISES LLC publica esta politica para las compras realizadas en FOMOPLANES. Antes de pagar, el comprador debe revisar fecha, funcion, localidad, cantidad de entradas, datos del asistente y cualquier condicion especial del evento. Las compras confirmadas no admiten cambios, devoluciones ni reembolsos por errores del comprador.',
      'Los fees de servicio, cargos de procesamiento y valores operativos aceptados durante el checkout no son reembolsables, salvo que la ley aplicable o una autorizacion expresa del organizador dispongan algo distinto.',
      'Si un evento se cancela de forma oficial, la responsabilidad sobre la cancelacion, el reembolso, el credito o cualquier instruccion operativa recae en el organizador del evento. GINGO ENTERPRISES LLC no es responsable por esa cancelacion ni por la decision final del organizador, aunque puede colaborar con la gestion cuando exista autorizacion previa y segun las condiciones del procesador de pago correspondiente.',
      'Si un evento se reprograma, la validez de la entrada, las opciones de uso o cualquier reembolso dependeran exclusivamente de la politica informada para ese evento y de la autorizacion del organizador. GINGO ENTERPRISES LLC no es responsable por la reprogramacion ni por cambios operativos definidos por terceros.',
      'Si agregaste Fomo Safe durante el checkout, su valor se cobra como addon independiente. Fomo Safe puede cubrir compras elegibles por imprevistos personales validables o por cancelacion oficial del evento, segun revision documental y validacion interna de GINGO ENTERPRISES LLC.',
    ],
  },
  contact: {
    label: 'Contacto',
    eyebrow: 'Atencion y soporte',
    title: 'Contacto',
    lead: 'Canales publicos para compras, pagos, accesos, incidencias de eventos y consultas generales sobre la plataforma.',
    paragraphs: [
      'FOMOPLANES es operado por GINGO ENTERPRISES LLC. Direccion comercial registrada: 1209 MOUNTAIN ROAD PL NE STE R, ALBUQUERQUE, NM 87110, Estados Unidos.',
      'Para soporte de compras conviene escribir desde el correo asociado a la orden e incluir nombre del comprador, evento, numero de pedido y una descripcion clara de la incidencia.',
      'Si la consulta esta relacionada con Stripe u otro procesador, incluye fecha aproximada, monto y cualquier captura relevante del error o comprobante para agilizar la revision.',
    ],
    highlights: [
      'Correo oficial: fomoplanes@sudenec.com',
      'Empresa registrada en Estados Unidos',
      'Ruta para organizadores: Lanza tu evento',
    ],
  },
  company: {
    label: 'Compania',
    eyebrow: 'Compania y operacion',
    title: 'Compania',
    lead: 'Resumen de la identidad legal de FOMOPLANES y del rol de su operador frente a compradores, organizadores y procesadores de pago.',
    paragraphs: [
      'FOMOPLANES es operado por GINGO ENTERPRISES LLC. Direccion comercial registrada: 1209 MOUNTAIN ROAD PL NE STE R, ALBUQUERQUE, NM 87110, Estados Unidos.',
      'GINGO ENTERPRISES LLC opera FOMOPLANES como plataforma digital para descubrir experiencias, promocionar eventos y facilitar la venta, emision y validacion de accesos de terceros y de experiencias identificadas expresamente como propias o coorganizadas.',
      'Los organizadores son responsables por la informacion comercial del evento, su ejecucion, condiciones operativas, cambios de programacion y autorizaciones de reembolso cuando corresponda. GINGO ENTERPRISES LLC puede actuar a traves de FOMOPLANES como canal de distribucion, promocion, soporte y coordinacion operativa.',
      'GINGO ENTERPRISES LLC puede trabajar con Stripe y otros procesadores autorizados para cobrar entradas, addons y servicios relacionados. Cada operacion puede estar sujeta a controles antifraude, autenticaciones reforzadas, revisiones documentales y reglas regulatorias del metodo de pago utilizado.',
    ],
    highlights: [
      'Operador legal: GINGO ENTERPRISES LLC',
      'Pais de operacion legal: Estados Unidos',
      'Soporte oficial: fomoplanes@sudenec.com',
    ],
  },
}

const LEGAL_ORDER = ['terms', 'privacy', 'refunds', 'contact', 'company']

export default {
  name: 'TermsModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    view: {
      type: String,
      default: 'terms',
    },
  },
  emits: ['update:modelValue', 'update:view'],
  data() {
    return {
      activeView: 'terms',
    }
  },
  computed: {
    activeContent() {
      return LEGAL_SECTIONS[this.activeView] || LEGAL_SECTIONS.terms
    },
    sectionOrder() {
      return LEGAL_ORDER.map((key) => ({
        key,
        label: LEGAL_SECTIONS[key].label,
      }))
    },
  },
  watch: {
    view: {
      immediate: true,
      handler(value) {
        this.activeView = this.normalizeView(value)
      },
    },
    modelValue(isOpen) {
      if (isOpen) {
        this.activeView = this.normalizeView(this.view)
        this.focusModalStart()
      }
    },
  },
  methods: {
    focusModalStart() {
      this.$nextTick(() => {
        const body = this.$refs.body
        const dialog = this.$refs.dialog

        if (body && typeof body.scrollTo === 'function') {
          body.scrollTo({ top: 0, behavior: 'auto' })
        }

        if (dialog && typeof dialog.focus === 'function') {
          dialog.focus({ preventScroll: true })
        }
      })
    },
    normalizeView(value) {
      return Object.prototype.hasOwnProperty.call(LEGAL_SECTIONS, value) ? value : 'terms'
    },
    setView(value) {
      const normalized = this.normalizeView(value)
      this.activeView = normalized
      this.$emit('update:view', normalized)
      this.focusModalStart()
    },
    closeModal() {
      this.$emit('update:modelValue', false)
    },
  },
}
</script>

<style scoped>
.terms-modal {
  position: fixed;
  inset: 0;
  z-index: 2000;
  display: grid;
  place-items: center;
  padding: 20px;
  background: rgba(5, 7, 12, 0.74);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}

.terms-modal__dialog {
  width: min(760px, 100%);
  max-height: min(88vh, 920px);
  overflow: hidden;
  border-radius: 24px;
  border: 1px solid rgba(198, 208, 230, 0.1);
  background:
    radial-gradient(circle at top left, rgba(210, 219, 236, 0.08), transparent 18%),
    radial-gradient(circle at 80% 18%, rgba(44, 36, 72, 0.18), transparent 28%),
    linear-gradient(180deg, rgba(255, 255, 255, 0.03), rgba(255, 255, 255, 0.008)),
    rgba(4, 6, 12, 0.98);
  box-shadow: 0 28px 70px rgba(0, 0, 0, 0.34);
  backdrop-filter: blur(24px) saturate(140%);
}

.terms-modal__header,
.terms-modal__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 18px 22px;
}

.terms-modal__header {
  border-bottom: 1px solid rgba(198, 208, 230, 0.1);
}

.terms-modal__footer {
  border-top: 1px solid rgba(198, 208, 230, 0.1);
}

.terms-modal__eyebrow {
  display: block;
  margin-bottom: 4px;
  color: #b8c2d8;
  font-size: 0.72rem;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.terms-modal__header h3 {
  margin: 0;
  color: #f4f7ff;
  font-size: 1.2rem;
}

.terms-modal__close,
.terms-modal__action {
  border: 1px solid rgba(198, 208, 230, 0.12);
  background: rgba(255, 255, 255, 0.04);
  color: #f4f7ff;
}

.terms-modal__close {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 999px;
}

.terms-modal__tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding: 14px 22px 0;
}

.terms-modal__tab {
  min-height: 38px;
  padding: 0 14px;
  border-radius: 999px;
  border: 1px solid rgba(198, 208, 230, 0.08);
  background: rgba(255, 255, 255, 0.04);
  color: #c8d1e4;
  font: inherit;
  font-size: 0.84rem;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.04);
  transition: background 180ms ease, border-color 180ms ease, color 180ms ease;
}

.terms-modal__tab:hover,
.terms-modal__tab.is-active {
  color: #f4f7ff;
  border-color: rgba(198, 208, 230, 0.16);
  background: rgba(106, 90, 141, 0.16);
}

.terms-modal__action {
  min-height: 42px;
  padding: 0 18px;
  border-radius: 999px;
  font-weight: 600;
}

.terms-modal__body {
  overflow: auto;
  max-height: calc(88vh - 206px);
  padding: 22px;
  color: #c8d1e4;
  line-height: 1.65;
}

.terms-modal__lead {
  margin: 0 0 18px;
  color: #eef3ff;
  font-weight: 600;
  line-height: 1.72;
}

.terms-modal__prose p {
  margin: 0 0 14px;
}

.terms-modal__list {
  display: grid;
  gap: 10px;
  margin: 18px 0 0;
  padding: 16px 18px 16px 34px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(198, 208, 230, 0.1);
}

.terms-modal__list li {
  color: #c8d1e4;
}

.terms-modal__footer-copy {
  color: #b8c2d8;
  font-size: 0.84rem;
}

.terms-modal-fade-enter-active,
.terms-modal-fade-leave-active {
  transition: opacity 0.18s ease;
}

.terms-modal-fade-enter-from,
.terms-modal-fade-leave-to {
  opacity: 0;
}

@media (max-width: 640px) {
  .terms-modal {
    padding: 10px;
  }

  .terms-modal__dialog {
    border-radius: 20px;
    max-height: 85vh;
  }

  .terms-modal__header,
  .terms-modal__footer {
    gap: 12px;
    padding: 14px;
  }

  .terms-modal__header h3 {
    font-size: 1.06rem;
  }

  .terms-modal__close {
    width: 36px;
    height: 36px;
  }

  .terms-modal__tabs {
    flex-wrap: nowrap;
    gap: 8px;
    padding: 10px 14px 0;
    overflow-x: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
  }

  .terms-modal__tabs::-webkit-scrollbar {
    display: none;
  }

  .terms-modal__body {
    max-height: calc(85vh - 164px);
    padding: 16px 14px 18px;
  }

  .terms-modal__footer {
    align-items: stretch;
    flex-direction: column;
  }

  .terms-modal__lead {
    margin-bottom: 14px;
    font-size: 0.95rem;
    line-height: 1.64;
  }

  .terms-modal__prose p,
  .terms-modal__list li {
    font-size: 0.91rem;
    line-height: 1.6;
  }

  .terms-modal__prose p {
    margin-bottom: 12px;
  }

  .terms-modal__list {
    margin-top: 14px;
    padding: 14px 14px 14px 28px;
    gap: 8px;
  }

  .terms-modal__action,
  .terms-modal__footer-copy {
    width: 100%;
    text-align: center;
  }

  .terms-modal__action {
    min-height: 38px;
  }

  .terms-modal__footer-copy {
    font-size: 0.78rem;
  }

  .terms-modal__tab {
    flex: 0 0 auto;
    width: auto;
    min-height: 34px;
    padding: 0 12px;
    font-size: 0.79rem;
  }
}
</style>
